import '../../../../../css/web/hotelcamprodon/empresa.css';


// Capçalera de les pàgines estàndard (legals, empresa, blog, ajuda...) amb
// el disseny de Camprodon: subtítol en versaletes bordeus i títol gran
// centrat, sense foto a sang (com els "Textos legals" de l'original). Si la
// pàgina té imatge de capçalera a la BBDD, surt a sota del títol.
// "compacto", "logo" i "migas" es mantenen per compatibilitat amb les
// pàgines que els passen.
// eslint-disable-next-line no-unused-vars
const CabeceraPagina = ({ titulo, eyebrow, imagen, logo, compacto = false, migas }) => (
    <div className="hc">
        <header className="hc-cabecera o-container">
            {eyebrow && <div className="hc-cabecera__small-title">{eyebrow}</div>}
            <h1 className="hc-cabecera__title">{titulo}</h1>
            {imagen && (
                <div className="hc-cabecera__imatge">
                    {/* Si la imatge de la BBDD no existeix, fora el requadre buit. */}
                    <img src={imagen} alt={titulo} className="image-cover" loading="lazy" decoding="async" onError={(e) => { e.currentTarget.parentElement.style.display = "none"; }} />
                </div>
            )}
        </header>
    </div>
);

export default CabeceraPagina;
